import {
  CLEAR_TRACKED_EMAIL_DETAIL,
  FETCH_TRACKED_EMAIL_DETAIL_ASYNC,
  FETCH_TRACKED_EMAILS_ASYNC,
  FETCH_TRACKED_EMAILS_SUMMARY_ASYNC,
  FETCH_TRIGGER_POLICIES_CONFIG_ASYNC,
  FETCH_TRIGGER_POLICIES_SCHEMA_ASYNC,
  GO_TO_TRACKED_EMAILS_NEXT_PAGE,
  GO_TO_TRACKED_EMAILS_PREV_PAGE,
  SET_TRACKED_EMAILS_FILTERS,
} from './constants'

export const setTrackedEmailsFilters = (filters = {}) => ({
  type: SET_TRACKED_EMAILS_FILTERS,
  payload: { filters },
})

export const goToTrackedEmailsNextPage = () => ({
  type: GO_TO_TRACKED_EMAILS_NEXT_PAGE,
})

export const goToTrackedEmailsPrevPage = () => ({
  type: GO_TO_TRACKED_EMAILS_PREV_PAGE,
})

export const fetchTrackedEmails = (filters = {}) => ({
  type: FETCH_TRACKED_EMAILS_ASYNC.INITIATE,
  payload: { filters },
})

export const fetchTrackedEmailsSuccess = (data) => ({
  type: FETCH_TRACKED_EMAILS_ASYNC.SUCCESS,
  payload: { data },
})

export const fetchTrackedEmailsError = (error) => ({
  type: FETCH_TRACKED_EMAILS_ASYNC.ERROR,
  error,
})

export const fetchTrackedEmailsSummary = (timeFrame, companyId) => ({
  type: FETCH_TRACKED_EMAILS_SUMMARY_ASYNC.INITIATE,
  payload: { timeFrame, companyId },
})

export const fetchTrackedEmailsSummarySuccess = (data) => ({
  type: FETCH_TRACKED_EMAILS_SUMMARY_ASYNC.SUCCESS,
  payload: { data },
})

export const fetchTrackedEmailsSummaryError = (error) => ({
  type: FETCH_TRACKED_EMAILS_SUMMARY_ASYNC.ERROR,
  error,
})

export const fetchTrackedEmailDetail = (messageIdNormalized) => ({
  type: FETCH_TRACKED_EMAIL_DETAIL_ASYNC.INITIATE,
  payload: { messageIdNormalized },
})

export const fetchTrackedEmailDetailSuccess = (data) => ({
  type: FETCH_TRACKED_EMAIL_DETAIL_ASYNC.SUCCESS,
  payload: { data },
})

export const fetchTrackedEmailDetailError = (error) => ({
  type: FETCH_TRACKED_EMAIL_DETAIL_ASYNC.ERROR,
  error,
})

export const clearTrackedEmailDetail = () => ({
  type: CLEAR_TRACKED_EMAIL_DETAIL,
})

export const fetchTriggerPoliciesSchema = () => ({
  type: FETCH_TRIGGER_POLICIES_SCHEMA_ASYNC.INITIATE,
})
export const fetchTriggerPoliciesSchemaSuccess = (data) => ({
  type: FETCH_TRIGGER_POLICIES_SCHEMA_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchTriggerPoliciesSchemaError = (error) => ({
  type: FETCH_TRIGGER_POLICIES_SCHEMA_ASYNC.ERROR,
  error,
})

export const fetchTriggerPoliciesConfig = () => ({
  type: FETCH_TRIGGER_POLICIES_CONFIG_ASYNC.INITIATE,
})
export const fetchTriggerPoliciesConfigSuccess = (data) => ({
  type: FETCH_TRIGGER_POLICIES_CONFIG_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchTriggerPoliciesConfigError = (error) => ({
  type: FETCH_TRIGGER_POLICIES_CONFIG_ASYNC.ERROR,
  error,
})

export default {
  setTrackedEmailsFilters,
  goToTrackedEmailsNextPage,
  goToTrackedEmailsPrevPage,
  fetchTrackedEmails,
  fetchTrackedEmailsSummary,
  fetchTrackedEmailDetail,
  clearTrackedEmailDetail,
  fetchTriggerPoliciesSchema,
  fetchTriggerPoliciesConfig,
}
